import BaseModelInstance from './base.model'
import { Usertype as ModelDefinition } from './model-definitions'

class Usertype extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default Usertype
